import { Download, Link2 } from "lucide-react";
import { toast } from "sonner";

const copyShareLink = async () => {
  const url = `${window.location.origin}/train-whistle-cessation.pdf`;
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Report link copied — share it anywhere.");
  } catch {
    toast.info(`Share this link: ${url}`);
  }
};

export const WhistleCessation = () => {
  return (
    <section
      id="whistles"
      className="scroll-mt-36 border-t border-[#DCDCD6] px-6 py-24 md:scroll-mt-24 md:py-32"
      data-testid="whistle-section"
    >
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          Quiet Nights Are Possible
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
          Train Whistle Cessation
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#666666]">
          Up to 350 train whistles disrupt Collins-Bayridge every day. The
          City of Kingston's own review — a report to Mayor and Council on
          nighttime whistle cessation along the CN Rail corridor — confirms
          the technical requirements can be met with modest safety upgrades
          at each crossing. Read the report and judge for yourself.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="/train-whistle-cessation.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whistle-download-button"
            className="flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Read the report
            <Download className="h-4 w-4" />
          </a>
          <button
            onClick={copyShareLink}
            data-testid="whistle-share-button"
            className="flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Copy share link
            <Link2 className="h-4 w-4" />
          </button>
        </div>
        <p className="mt-6 text-[10px] font-bold uppercase tracking-[0.25em] text-[#999999]">
          City of Kingston — Report to Mayor and Council
        </p>
      </div>
    </section>
  );
};
